export const CONFIRMED = 'CONFIRMED';
export const PENDING = 'PENDING';
export const DISABLED = 'DISABLED';